import React, { forwardRef, useImperativeHandle } from "react";
import ReactDOM from "react-dom";
import Axios from "axios";
import { Modal as AntdModal } from "antd";
import ModalSimple from "../../../Layout/Modals/ModalSimple";
import ModalSpecial from "../../../Layout/Modals/ModalSpecial";
import LayoutOfTablesModal from "./layoutOfTablesModal";
import CategoryFilterModal from "./categoryFilterModal";
import SupplierFilterModal from "./SupplierFilterModal";
import StatusFilterModal from "./StatusFilterModal";
import OrderShowModal from "../../../common/GlobalModals/Orders/orderShowModal";
import { getSuppliersOption } from "../../../../redux/Actions/supplierAction";
import { removeOverFlow, addOverFlow } from "../../../../helpers/modalFunc";
import OrderCreateModal from "../../../common/GlobalModals/Orders/OrderCreateModal";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../../common/Spinner";
import { CommentStateType } from "../../../common/CommentState_type";
import { onFilterUpdateWithUser } from "../../../../redux/Actions/filtersAction";
import { setOrderSettings } from "../../../../redux/Actions/orderAction";
import ModalActionHistory from "../features/action_history/ModalActionHistory";
import { Alert } from "../../../globals";
import { AiOutlineAlert, AiOutlineInfoCircle, AiOutlineFileSearch } from "react-icons/ai";

const Modal = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const order_id = useSelector((state) => state.orders.order?.id_order || "");
  // Api loggers endpoint is scoped by the order's DB primary key, not the display id_order
  const orderPk = useSelector((state) => state.orders.order?.id);
  const { loading_order, error_order } = useSelector((state) => state.orders);
  const validate_comments = useSelector(
    (state) => state.orders.validate_comments
  );
  const customerBlacklisted = useSelector(
    (state) => state.orders.order?.customer?.blacklisted_at
  );
  const userRoleTitle = useSelector(
    (state) => state.auth.user?.user_role?.title
  );
  const isSuperAdmin = userRoleTitle?.toLowerCase() === "super admin";

  const [display, setDisplay] = React.useState("first");
  const [SupplySupplierData, setSupplySupplierData] = React.useState([]);
  const [isApiLogsModalOpen, setIsApiLogsModalOpen] = React.useState(false);
  const [apiLogsLoading, setApiLogsLoading] = React.useState(false);
  const [apiLogsError, setApiLogsError] = React.useState(null);
  const [apiLogsData, setApiLogsData] = React.useState([]);

  React.useEffect(() => {
    setIsApiLogsModalOpen(false);
    setApiLogsLoading(false);
    setApiLogsError(null);
    setApiLogsData([]);
  }, [orderPk]);

  useImperativeHandle(ref, () => {
    return {
      openModal: (active) => open(active),
      close: () => close(),
      active: display,
    };
  });

  const open = (active) => {
    requestOfOptions();
    addOverFlow();
    setDisplay(active);
  };

  const close = () => {
    removeOverFlow();
    setIsApiLogsModalOpen(false);
    setDisplay(false);
  };

  const fetchApiLoggers = async () => {
    if (!orderPk || apiLogsLoading) {
      return;
    }

    setApiLogsLoading(true);
    setApiLogsError(null);

    try {
      const { data } = await Axios.get(
        `/api/v1/orders/${orderPk}/api_loggers`
      );
      const payload = Array.isArray(data?.data) ? data.data : [];
      setApiLogsData(payload);
    } catch (error) {
      setApiLogsError(error?.response?.data || "Failed to load api logs");
    } finally {
      setApiLogsLoading(false);
    }
  };

  const openApiLogsModal = () => {
    setIsApiLogsModalOpen(true);
    fetchApiLoggers();
  };

  const formatApiLogDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    const pad = (part) => String(part).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
      date.getSeconds()
    )}`;
  };

  const requestOfOptions = () => {
    getSuppliersOption().then((response) => {
      if (response.data) {
        let newArray = [];
        response.data.data.forEach((item) => {
          const findIndex = newArray.findIndex(
            (find) => find.name == item.name
          );
          if (findIndex == -1) {
            return newArray.push({
              value: item.id,
              name: item.name,
              code: item.code,
              label: item.title || item.name,
              is_code: item.is_code,
            });
          }
        });
        setSupplySupplierData(newArray);
      }
    });


    console.count("Request times:");
  };

  if (display == "LayoutOfTablesModal") {
    return ReactDOM.createPortal(
      <ModalSimple
        text={"Table layout"}
        handleSave={() => { }}
        onClose={() => close()}
      >
        <LayoutOfTablesModal
          layoutOfTable={props.layoutOfTable}
          layoutOfTablesFunc={props.layoutOfTablesFunc}
        />
      </ModalSimple>,
      document.getElementById("modal-roots")
    );
  }

  if (display == "CategoryFilterModal") {
    return ReactDOM.createPortal(
      <ModalSimple
        text={"Filter by categories"}
        secondButton={() =>
          dispatch(
            onFilterUpdateWithUser([], "user_categories", "categoryFilter")
          )
        }
        secondButtonText="Clear the category filter"
        onClose={() => {
          close();
          // props.updateOrderFilter();
        }}
      >
        <CategoryFilterModal />
      </ModalSimple>,
      document.getElementById("modal-roots")
    );
  }
  if (display == "ModalActionHistory") {
    return ReactDOM.createPortal(
      <ModalSimple
        text={"Actions history"}
        onClose={() => {
          close();
        }}
      >
        <ModalActionHistory />
      </ModalSimple>,
      document.getElementById("modal-roots")
    );
  }
  if (display == "SupplierFilterModal") {
    return ReactDOM.createPortal(
      <ModalSimple
        text={"Filter by shipping to customer"}
        secondButton={async () => {
          await dispatch(
            onFilterUpdateWithUser([], "user_suppliers", "user_suppliers")
          );
          dispatch(setOrderSettings({ page: 1 }));
        }}
        secondButtonText="Clear the supplier filter"
        onClose={() => {
          close();
          // props.updateOrderFilter();
        }}
      >
        <SupplierFilterModal />
      </ModalSimple>,
      document.getElementById("modal-roots")
    );
  }

  if (display == "StatusFilterModal") {
    return ReactDOM.createPortal(
      <ModalSimple
        text={"Filter by status"}
        secondButton={() =>
          dispatch(onFilterUpdateWithUser([], "user_statuses", "statusFilter"))
        }
        secondButtonText="Clear the status filter"
        onClose={() => {
          close();
          // props.updateOrderFilter();
        }}
      >
        <StatusFilterModal options={props.avalaibleStatus} />
      </ModalSimple>,
      document.getElementById("modal-roots")
    );
  }

  if (display == "OrderShowModal") {
    const tilteSpan = (
      <span
        style={{
          fontSize: "1.2rem",
          lineHeight: "27px",
          color: "#000000",
          fontWeight: "700",
        }}
      >
        Order <span className="text-orange">#</span>
        {order_id}
        {/* {this.state.id_order} */}
        {!!customerBlacklisted && (
          <span
            className="ml-3"
            style={{ fontSize: "1rem", color: "#dc3545", fontWeight: "600" }}
          >
            <AiOutlineInfoCircle
              className="text-danger mr-2"
              style={{ fontSize: 17 }}
            />{" "}
            Blacklist client order
          </span>
        )}
      </span>
    );

    return ReactDOM.createPortal(
      <>
        <ModalSpecial
          text={tilteSpan}
          handleSave={() => { }}
          maskClosable
          headerAction={
            isSuperAdmin ? (
              <button
                type="button"
                className="initial-button d-flex align-items-center text-black"
                style={{ fontSize: "14px", fontWeight: 600 }}
                title="Order API logs"
                aria-label="Order API logs"
                onClick={openApiLogsModal}
              >
                <AiOutlineFileSearch size={20} />
              </button>
            ) : null
          }
          onClose={() => {
            if (Object.values(validate_comments).some((d) => d)) {
              if (
                confirm(
                  `Are you sure want to close modal with unposted comments ? Unposted: ${Object.entries(
                    validate_comments
                  )
                    .filter((d) => d[1])
                    .map((d) => CommentStateType(d[0]))
                    .join(", ")}`
                )
              )
                return close();
            } else {
              close();
            }
          }}
        >
          {loading_order ? (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ height: "100%" }}
            >
              <Spinner />
            </div>
          ) : !!error_order ? (
            <Alert message={error_order} type="error" />
          ) : (
            <OrderShowModal
              supplySupplier={SupplySupplierData}
              avalaibleStatus={props.avalaibleStatus}
              comments_state={props.comments_state_all}
            />
          )}
        </ModalSpecial>

        <AntdModal
          visible={isApiLogsModalOpen}
          title={`Order #${order_id} API logs`}
          onCancel={() => setIsApiLogsModalOpen(false)}
          footer={null}
          width={900}
        >
          {apiLogsLoading ? (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ minHeight: "120px" }}
            >
              <Spinner />
            </div>
          ) : apiLogsError ? (
            <div className="text-danger">{String(apiLogsError)}</div>
          ) : apiLogsData.length === 0 ? (
            <div>No API logs for this order.</div>
          ) : (
            <div style={{ maxHeight: "70vh", overflow: "auto" }}>
              {apiLogsData.map((logger) => (
                <div
                  key={logger.id}
                  className="mb-3 pb-2"
                  style={{ borderBottom: "1px solid #e9ecef" }}
                >
                  <div className="d-flex justify-content-between mb-2">
                    <strong>{logger.log_item || "-"}</strong>
                    <span>{formatApiLogDate(logger.created_at)}</span>
                  </div>
                  <pre
                    style={{
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      background: "#f8f9fa",
                      borderRadius: "4px",
                      padding: "8px",
                      marginBottom: 0,
                    }}
                  >
                    {logger.body || "-"}
                  </pre>
                </div>
              ))}
            </div>
          )}
        </AntdModal>
      </>,
      document.getElementById("modal-roots")
    );
  }

  if (display == "OrderCreateModal") {
    const tilteSpan = (
      <span
        style={{
          fontSize: "1.2rem",
          lineHeight: "27px",
          color: "#000000",
          fontWeight: "700",
        }}
      >
        Creating an <span className="text-orange">order</span>
      </span>
    );

    return ReactDOM.createPortal(
      <ModalSpecial
        text={tilteSpan}
        handleSave={() => { }}
        onClose={() => close()}
      >
        <OrderCreateModal
          payment_types={props.payment_types}
          carriers={props.carriers}
          avalaibleStatus={props.avalaibleStatus}
          onClose={() => close()}
        />
      </ModalSpecial>,
      document.getElementById("modal-roots")
    );
  }

  return null;
});

export default Modal;
